import { RootState } from "@redux/app/store"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { BwPositionData, BwVesselData, BwVesselTrackData, PlantInfo } from "api"

export interface PlantInfoValidated extends PlantInfo {
	vessel?: BwVesselData
	position?: BwPositionData
	track?: BwVesselTrackData
}

export interface PlantInfoFE extends PlantInfoValidated {
	latestOperationMode2?: { plantId: number; opModeName: string }
	lengthOA?: number
	breadthMld?: number
}

type State = {
	loaded: boolean
	vessels: PlantInfoFE[]
}

const initialState: State = {
	loaded: false,
	vessels: [],
}

const listOfVesselsSlice = createSlice({
	name: "listOfVessels",
	initialState,
	reducers: {
		setListOfVessels(state, action: PayloadAction<State>) {
			return { ...state, ...action.payload }
		},
		upsertListOfVessels(state, action: PayloadAction<PlantInfoFE[]>) {
			const vesselsByPlantId = new Map(
				state.vessels.map((vessel) => [vessel.plantId, vessel])
			)
			for (const vessel of action.payload) {
				vesselsByPlantId.set(vessel.plantId, vessel)
			}
			return {
				...state,
				loaded: true,
				vessels: Array.from(vesselsByPlantId.values()),
			}
		},
	},
})

export const getListOfVessels = (state: RootState) => state.listOfVessels

export const { setListOfVessels, upsertListOfVessels } = listOfVesselsSlice.actions

export default listOfVesselsSlice.reducer
